import { render, staticRenderFns } from "./P1-1.vue?vue&type=template&id=471e807c&scoped=true"
import script from "./P1-1.vue?vue&type=script&lang=js"
export * from "./P1-1.vue?vue&type=script&lang=js"
import style0 from "./P1-1.vue?vue&type=style&index=0&id=471e807c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e807c",
  null
  
)

export default component.exports